<div class="wizard">
  <ul>
    <li [class.d-none]="step.hiddenStep" [ngClass]="{'active': step.active || step.completed}"
      *ngFor="let step of wizardSteps">
      <span placement="bottom" [tooltip]="step.title" [delay]="500">{{ step.title }}</span>
    </li>
  </ul>
  <ng-content></ng-content>
</div>